{
  "af": {
    "countryCode": "na",
    "countries": [
      "za",
      "na"
    ]
  },
  "am": {
    "countryCode": "et",
    "countries": [
      "et"
    ]
  },
  "ar": {
    "countryCode": "lb",
    "countries": [
      "dz",
      "bh",
      "td",
      "km",
      "dj",
      "eg",
      "er",
      "iq",
      "jo",
      "kw",
      "lb",
      "ly",
      "mr",
      "ma",
      "om",
      "ps",
      "qa",
      "sa",
      "so",
      "sd",
      "sy",
      "tn",
      "ae",
      "ye"
    ]
  },
  "ay": {
    "countryCode": "bo",
    "countries": [
      "bo",
      "pe"
    ]
  },
  "az": {
    "countryCode": "az",
    "countries": [
      "az"
    ]
  },
  "be": {
    "countryCode": "by",
    "countries": [
      "by"
    ]
  },
  "bg": {
    "countryCode": "bg",
    "countries": [
      "bg"
    ]
  },
  "bi": {
    "countryCode": "vu",
    "countries": [
      "vu"
    ]
  },
  "bn": {
    "countryCode": "bd",
    "countries": [
      "bd",
      "in"
    ]
  },
  "bs": {
    "countryCode": "ba",
    "countries": [
      "ba"
    ]
  },
  "ca": {
    "countryCode": "ad",
    "countries": [
      "ad"
    ]
  },
  "ch": {
    "countryCode": "gu",
    "countries": [
      "gu",
      "mp"
    ]
  },
  "cs": {
    "countryCode": "cz",
    "countries": [
      "cz"
    ]
  },
  "da": {
    "countryCode": "dk",
    "countries": [
      "dk",
      "fo",
      "gl"
    ]
  },
  "de": {
    "countryCode": "de",
    "countries": [
      "de",
      "at",
      "be",
      "li",
      "lu",
      "ch"
    ]
  },
  "dv": {
    "countryCode": "mv",
    "countries": [
      "mv"
    ]
  },
  "el": {
    "countryCode": "gr",
    "countries": [
      "gr",
      "cy"
    ]
  },
  "en": {
    "countryCode": "gb",
    "countries": [
      "ag",
      "au",
      "bs",
      "bb",
      "bz",
      "bw",
      "cm",
      "ca",
      "dm",
      "sz",
      "fj",
      "gm",
      "gh",
      "gd",
      "gy",
      "in",
      "ie",
      "jm",
      "ke",
      "ki",
      "ls",
      "lr",
      "mw",
      "mt",
      "mh",
      "mu",
      "fm",
      "na",
      "nr",
      "nz",
      "ng",
      "pk",
      "pw",
      "pg",
      "ph",
      "rw",
      "kn",
      "lc",
      "vc",
      "ws",
      "sc",
      "sl",
      "sg",
      "sb",
      "za",
      "ss",
      "sd",
      "tz",
      "to",
      "tt",
      "tv",
      "ug",
      "gb",
      "us",
      "vu",
      "zm",
      "zw"
    ]
  },
  "es": {
    "countryCode": "es",
    "countries": [
      "ar",
      "bo",
      "cl",
      "co",
      "cr",
      "cu",
      "do",
      "ec",
      "sv",
      "gq",
      "gt",
      "hn",
      "mx",
      "ni",
      "pa",
      "py",
      "pe",
      "es",
      "uy",
      "ve"
    ]
  },
  "et": {
    "countryCode": "ee",
    "countries": [
      "ee"
    ]
  },
  "fa": {
    "countryCode": "ir",
    "countries": [
      "ir",
      "af",
      "tj"
    ]
  },
  "ff": {
    "countryCode": "gn",
    "countries": [
      "gn",
      "sn",
      "gw",
      "ml"
    ]
  },
  "fi": {
    "countryCode": "fi",
    "countries": [
      "fi"
    ]
  },
  "fj": {
    "countryCode": "fj",
    "countries": [
      "fj"
    ]
  },
  "fo": {
    "countryCode": "fo",
    "countries": [
      "fo"
    ]
  },
  "fr": {
    "countryCode": "fr",
    "countries": [
      "be",
      "bj",
      "bf",
      "bi",
      "cm",
      "ca",
      "cf",
      "td",
      "km",
      "cg",
      "cd",
      "ci",
      "dj",
      "gq",
      "fr",
      "ga",
      "gn",
      "ht",
      "lu",
      "mg",
      "ml",
      "mc",
      "ne",
      "rw",
      "sn",
      "sc",
      "ch",
      "tg",
      "vu"
    ]
  },
  "ga": {
    "countryCode": "ie",
    "countries": [
      "ie"
    ]
  },
  "gn": {
    "countryCode": "py",
    "countries": [
      "py"
    ]
  },
  "gv": {
    "countryCode": "im",
    "countries": [
      "im"
    ]
  },
  "he": {
    "countryCode": "il",
    "countries": [
      "il"
    ]
  },
  "hi": {
    "countryCode": "in",
    "countries": [
      "in",
      "fj"
    ]
  },
  "hr": {
    "countryCode": "hr",
    "countries": [
      "hr",
      "ba"
    ]
  },
  "ht": {
    "countryCode": "ht",
    "countries": [
      "ht"
    ]
  },
  "hu": {
    "countryCode": "hu",
    "countries": [
      "hu"
    ]
  },
  "hy": {
    "countryCode": "am",
    "countries": [
      "am"
    ]
  },
  "id": {
    "countryCode": "id",
    "countries": [
      "id"
    ]
  },
  "is": {
    "countryCode": "is",
    "countries": [
      "is"
    ]
  },
  "it": {
    "countryCode": "it",
    "countries": [
      "it",
      "sm",
      "ch",
      "va"
    ]
  },
  "ja": {
    "countryCode": "jp",
    "countries": [
      "jp"
    ]
  },
  "ka": {
    "countryCode": "ge",
    "countries": [
      "ge"
    ]
  },
  "kk": {
    "countryCode": "kz",
    "countries": [
      "kz"
    ]
  },
  "kl": {
    "countryCode": "gl",
    "countries": [
      "gl"
    ]
  },
  "km": {
    "countryCode": "kh",
    "countries": [
      "kh"
    ]
  },
  "ko": {
    "countryCode": "kr",
    "countries": [
      "kp",
      "kr"
    ]
  },
  "ku": {
    "countryCode": "iq",
    "countries": [
      "iq"
    ]
  },
  "ky": {
    "countryCode": "kg",
    "countries": [
      "kg"
    ]
  },
  "la": {
    "countryCode": "va",
    "countries": [
      "va"
    ]
  },
  "lb": {
    "countryCode": "lu",
    "countries": [
      "lu"
    ]
  },
  "ln": {
    "countryCode": "cd",
    "countries": [
      "cd",
      "cg"
    ]
  },
  "lo": {
    "countryCode": "la",
    "countries": [
      "la"
    ]
  },
  "lt": {
    "countryCode": "lt",
    "countries": [
      "lt"
    ]
  },
  "lv": {
    "countryCode": "lv",
    "countries": [
      "lv"
    ]
  },
  "mg": {
    "countryCode": "mg",
    "countries": [
      "mg"
    ]
  },
  "mh": {
    "countryCode": "mh",
    "countries": [
      "mh"
    ]
  },
  "mi": {
    "countryCode": "nz",
    "countries": [
      "nz"
    ]
  },
  "mk": {
    "countryCode": "mk",
    "countries": [
      "mk"
    ]
  },
  "mn": {
    "countryCode": "mn",
    "countries": [
      "mn"
    ]
  },
  "ms": {
    "countryCode": "sg",
    "countries": [
      "bn",
      "my",
      "sg"
    ]
  },
  "mt": {
    "countryCode": "mt",
    "countries": [
      "mt"
    ]
  },
  "my": {
    "countryCode": "mm",
    "countries": [
      "mm"
    ]
  },
  "na": {
    "countryCode": "nr",
    "countries": [
      "nr"
    ]
  },
  "nd": {
    "countryCode": "zw",
    "countries": [
      "zw"
    ]
  },
  "ne": {
    "countryCode": "np",
    "countries": [
      "np",
      "in"
    ]
  },
  "nl": {
    "countryCode": "nl",
    "countries": [
      "aw",
      "be",
      "cw",
      "nl",
      "sx",
      "sr"
    ]
  },
  "no": {
    "countryCode": "no",
    "countries": [
      "no",
      "sj"
    ]
  },
  "nr": {
    "countryCode": "za",
    "countries": [
      "za"
    ]
  },
  "ny": {
    "countryCode": "mw",
    "countries": [
      "mw",
      "zm"
    ]
  },
  "pl": {
    "countryCode": "pl",
    "countries": [
      "pl"
    ]
  },
  "ps": {
    "countryCode": "af",
    "countries": [
      "af",
      "pk"
    ]
  },
  "pt": {
    "countryCode": "pt",
    "countries": [
      "ao",
      "br",
      "cv",
      "gq",
      "gw",
      "mo",
      "mz",
      "pt",
      "st",
      "tl"
    ]
  },
  "rn": {
    "countryCode": "bi",
    "countries": [
      "bi"
    ]
  },
  "ro": {
    "countryCode": "ro",
    "countries": [
      "md",
      "ro"
    ]
  },
  "ru": {
    "countryCode": "ru",
    "countries": [
      "by",
      "kz",
      "kg",
      "ru"
    ]
  },
  "rw": {
    "countryCode": "rw",
    "countries": [
      "rw"
    ]
  },
  "sg": {
    "countryCode": "cf",
    "countries": [
      "cf"
    ]
  },
  "si": {
    "countryCode": "lk",
    "countries": [
      "lk"
    ]
  },
  "sk": {
    "countryCode": "sk",
    "countries": [
      "sk"
    ]
  },
  "sl": {
    "countryCode": "si",
    "countries": [
      "si"
    ]
  },
  "sm": {
    "countryCode": "as",
    "countries": [
      "as",
      "ws"
    ]
  },
  "sn": {
    "countryCode": "zw",
    "countries": [
      "zw"
    ]
  },
  "so": {
    "countryCode": "so",
    "countries": [
      "dj",
      "et",
      "ke",
      "so"
    ]
  },
  "sq": {
    "countryCode": "al",
    "countries": [
      "al",
      "xk",
      "mk"
    ]
  },
  "sr": {
    "countryCode": "rs",
    "countries": [
      "ba",
      "xk",
      "me",
      "rs"
    ]
  },
  "ss": {
    "countryCode": "sz",
    "countries": [
      "sz",
      "za"
    ]
  },
  "st": {
    "countryCode": "ls",
    "countries": [
      "ls",
      "za"
    ]
  },
  "sv": {
    "countryCode": "se",
    "countries": [
      "fi",
      "se"
    ]
  },
  "sw": {
    "countryCode": "tz",
    "countries": [
      "ke",
      "tz",
      "ug"
    ]
  },
  "ta": {
    "countryCode": "lk",
    "countries": [
      "in",
      "lk",
      "sg"
    ]
  },
  "tg": {
    "countryCode": "tj",
    "countries": [
      "tj"
    ]
  },
  "th": {
    "countryCode": "th",
    "countries": [
      "th"
    ]
  },
  "ti": {
    "countryCode": "er",
    "countries": [
      "er",
      "et"
    ]
  },
  "tk": {
    "countryCode": "tm",
    "countries": [
      "tm"
    ]
  },
  "tn": {
    "countryCode": "bw",
    "countries": [
      "bw",
      "za"
    ]
  },
  "to": {
    "countryCode": "to",
    "countries": [
      "to"
    ]
  },
  "tr": {
    "countryCode": "tr",
    "countries": [
      "cy",
      "tr"
    ]
  },
  "uk": {
    "countryCode": "ua",
    "countries": [
      "ua"
    ]
  },
  "ur": {
    "countryCode": "pk",
    "countries": [
      "in",
      "pk"
    ]
  },
  "uz": {
    "countryCode": "uz",
    "countries": [
      "uz"
    ]
  },
  "vi": {
    "countryCode": "vn",
    "countries": [
      "vn"
    ]
  },
  "zh": {
    "countryCode": "cn",
    "countries": [
      "cn",
      "hk",
      "mo",
      "sg",
      "tw"
    ]
  },
  "om": {
    "countryCode": "et-or",
    "countries": [
      "et",
      "ke"
    ]
  }
}
